import {gql} from '@apollo/client';

import {doQuerySafe} from 'graphql-client/ApolloWrappers';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';

import {
  EntityMap,
  EntityMap_entityMap_EntityMapNode as EntityMapNode,
  EntityMapVariables,
} from './__generated/EntityMap';

export const ENTITY_MAP_QUERY = gql`
  query EntityMap($entityMapInput: EntityMapInputNode!) @skipAudit @engComponent(name: REGISTRY) {
    entityMap(entityMapInput: $entityMapInput) {
      ... on EntityMapNode {
        entities {
          ... on EntityMapEntityNode {
            id
            schemaName
            edgeCount
          }
          ... on InaccessibleInfoNode {
            ...InaccessibleInfoGraphQL
          }
        }
        edges {
          id
          sourceId
          targetId
        }
      }
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;

/**
 * Fetches the entity map graph for a given entityId and depth
 *
 * Throws an error if the data is unavailable or inaccessible.
 * @param entityId  The ID of the node to fetch the entity map for
 * @param depth  The depth of the entity map to fetch
 */
export async function fetchEntityMap(entityId: string, depth: number): Promise<EntityMapNode> {
  const result = await doQuerySafe<EntityMap, EntityMapVariables>(
    {query: ENTITY_MAP_QUERY},
    {variables: {entityMapInput: {entityId, depth}}}
  );

  if (result?.entityMap == null) {
    throw new Error('This data is not available.');
  }

  return result.entityMap;
}
